export default __webpack_public_path__ + "static/media/acads-app.c394dccb.jpeg";